import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunkAPIType } from "../../../app/appTypes";
import { deleteWithAuth, getWithAuth, postWithAuth } from "../../../http";
import { Supplier } from "../../suppliers/suppliersSlice";
import { Company } from "../companiesSlice";

export interface CompanyMapping {
    id: string;
    companyId: string;
    company: Company;
    supplierId: string;
    supplier: Supplier;
} 

export interface PotentialMapping {
    companyId: number;
    companyName: string;
    companyEmail: string;
    potentialSuppliers: PotentialSuppliers[]
}

export interface PotentialMappingWithSections extends PotentialMapping {
    selectedPotentialSuppliers: PotentialSuppliers[]
}

export interface PotentialSuppliers {
    id: string;
    supplierName: string;
    companyId: string;
    companyName: string;
    email: string;
}

export interface CompanyMappingPayload {
    companyId: string;
    supplierId: string;
} 

export interface CompanyMappingsPayload {
    companyId: string;
    suppliers: string[];
} 

export const loadCompanyMappings = createAsyncThunk<CompanyMapping[], void, AppThunkAPIType>("default-company-mappings/load", async (_, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(getWithAuth({ url: `api/sys/company-mappings` }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as CompanyMapping[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const loadCompanyMappingsByCompanyId = createAsyncThunk<CompanyMapping[], string, AppThunkAPIType>("default-company-mappings/load", async (companyId, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(getWithAuth({ url: `api/sys/company-mappings/${companyId}` }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as CompanyMapping[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const loadSuppliers = createAsyncThunk<Supplier[], void, AppThunkAPIType>("default-company-mappings/load-suppliers", async (_, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(getWithAuth({ url: `api/suppliers/all` }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as Supplier[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const loadPotentialMappings = createAsyncThunk<PotentialMapping[], void, AppThunkAPIType>("default-company-mappings/load-potential", async (_, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(getWithAuth({ url: `api/sys/company-mappings/potential` }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as PotentialMapping[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const loadPotentialMappingsForCompany = createAsyncThunk<PotentialMapping[], string, AppThunkAPIType>("default-company-mappings/load-potential", async (companyId, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(getWithAuth({ url: `api/sys/company-mappings/potential?companyId=${companyId}` }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as PotentialMapping[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const createCompanyMapping = createAsyncThunk<CompanyMapping, CompanyMappingPayload, AppThunkAPIType>("default-company-mappings/create", async (data, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(postWithAuth({ url: `api/sys/company-mappings`, payload: data }))
    const { payload } = result
    if (postWithAuth.fulfilled.match(result)) {
        return payload as CompanyMapping
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const createCompanyMappings = createAsyncThunk<CompanyMapping[], CompanyMappingsPayload, AppThunkAPIType>("default-company-mappings/create", async (data, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(postWithAuth({ url: `api/sys/company-mappings/multiple`, payload: data }))
    const { payload } = result
    if (postWithAuth.fulfilled.match(result)) {
        return payload as CompanyMapping[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const deleteCompanyMapping = createAsyncThunk<string, string, AppThunkAPIType>("default-company-mappings/delete", async (id, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(deleteWithAuth({ url: `api/sys/company-mappings/${id}` }))
    const { payload } = result
    if (deleteWithAuth.fulfilled.match(result)) {
        return payload as string;
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})